__turbopack_context__.v({
  "acceptStyle": "DragAndDrop-module-scss-module__BBZ_ma__acceptStyle",
  "baseStyle": "DragAndDrop-module-scss-module__BBZ_ma__baseStyle",
  "focusedStyle": "DragAndDrop-module-scss-module__BBZ_ma__focusedStyle",
  "hoverStyle": "DragAndDrop-module-scss-module__BBZ_ma__hoverStyle",
  "icon": "DragAndDrop-module-scss-module__BBZ_ma__icon",
  "image": "DragAndDrop-module-scss-module__BBZ_ma__image",
  "image-container": "DragAndDrop-module-scss-module__BBZ_ma__image-container",
  "message": "DragAndDrop-module-scss-module__BBZ_ma__message",
  "rejectStyle": "DragAndDrop-module-scss-module__BBZ_ma__rejectStyle",
});
